import React from 'react'

const Surveys = () => {
  return (
    <div>
      <p>Surveys</p>
    </div>
  )
}

export default Surveys
